import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { isAuthenticated } from "../lib/GlobalState";
import { useAtom } from "jotai";

const Dashboard = lazy(() => import("../layouts/Dashboard/Dashboard"));
const Auth = lazy(() => import("../layouts/Auth/Auth"));

const Home = lazy(() => import("../pages/home/home-page"));
const SignIn = lazy(() => import("../pages/SignIn/SignIn"));
const Recon = lazy(() => import("../pages/Recon/Recon"));
const MissingTransactions = lazy(
  () => import("../pages/MissingTransactions/MissingTransactions")
);
const User = lazy(() => import("../pages/user/user-page"));
const PendingAccounts = lazy(
  () => import("../pages/PendingAccounts/PendingAccounts")
);
const Challenges = lazy(() => import("../pages/Challenges/Challenges"));

const Fallback = lazy(() => import("../components/Fallback/Fallback"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound"));

export default function AppRoutes() {
  const [isUserAuthenticated] = useAtom(isAuthenticated);

  return (
    <BrowserRouter>
      <Suspense fallback={<Fallback />}>
        <Routes>
          {isUserAuthenticated ? (
            <Route path="/" element={<Dashboard />}>
              <Route index element={<Home />} />
              <Route path="recon" element={<Recon />} />
              <Route
                path="missing-transactions"
                element={<MissingTransactions />}
              />
              <Route path="user" element={<User />} />
              <Route path="pending-accounts" element={<PendingAccounts />} />
              <Route path="challenges" element={<Challenges />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          ) : (
            <Route path="/" element={<Auth />}>
              <Route index element={<SignIn />} />
              <Route path="*" element={<SignIn />} />
            </Route>
          )}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
